module.exports = __webpack_public_path__ + "static/media/presentingatrobosg.26d1fbdc.jpeg";